module.exports = __webpack_public_path__ + "static/media/opp_logo.2ee90f8e.svg";